export default function TableauIdInputStatement() {
  return <p>※大文字、小文字、数字、アンダースコア(_)のみ可能(50文字以内)</p>;
}
